import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {
  Event,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router';
// or if using ag-Grid Enterprise
import { ModuleRegistry, AllModules } from '@ag-grid-enterprise/all-modules';
import { FclService } from './core/services/fcl.service';
import { LoadingService } from './shared/components/loading/loading.service';
import { BehaviorSubject } from 'rxjs';
import { MessageDialogService } from './shared/components/message-dialog/message-dialog.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'NYSDOT: CLEAR Safety';
  routeLoading = false;
  public loadingModal = false;

  private routeLoadingTask: BehaviorSubject<boolean>;

  constructor(
    private router: Router,
    private fcl: FclService,
    private cdr: ChangeDetectorRef,
    private loading: LoadingService,
    public messageDialogService: MessageDialogService
  ) {
    ModuleRegistry.registerModules(AllModules);
    this.fcl.loadFlareClusterLayer();
  }

  ngOnInit() {
    //this.setupLoadingListener();
    (window as any).ClarityIcons.add({
      'zoom-no-plus': `<svg xmlns="http://www.w3.org/2000/svg"
        width="36" height="36" viewBox="0 0 36 36" preserveAspectRatio="xMidYMid meet"><title> 
        zoom-in-line</title><path d="M16 4A12 12 0 1 0 28 16 12 12 0 0 0 16 4Zm0 21.9A10 10 0 1 1 26 16 10 10 0 0 1 16 25.9Z" 
        class="clr-i-outline clr-i-outline-path-1"/><path d="M31.7 29.7l-5.2-5.2A13.7 13.7 0 0 1 25.2 26l5.2 5.2a1 1 0 0 0 1.4-1.4Z"
        class="clr-i-outline clr-i-outline-path-2"/><rect width="36" height="36" fill="none"/></svg>`,
      'road-volume': `<svg height='100px' width='100px'  fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" x="0px" y="0px"><title>road city urban town element</title><g data-name="Layer 30"><path d="M21.2168,21.9766A1.04,1.04,0,0,1,20.999,22a1.0014,1.0014,0,0,1-.9756-.7832l-4-18a1,1,0,0,1,1.9532-.4336l4,18A1.0014,1.0014,0,0,1,21.2168,21.9766Zm-14-19.9532a1.0085,1.0085,0,0,0-1.1934.76l-4,18a1.0014,1.0014,0,0,0,.76,1.1934A1.04,1.04,0,0,0,3.001,22a1.0014,1.0014,0,0,0,.9756-.7832l4-18A1.0014,1.0014,0,0,0,7.2168,2.0234ZM12,2a1,1,0,0,0-1,1V5a1,1,0,0,0,2,0V3A1,1,0,0,0,12,2Zm0,8a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V11A1,1,0,0,0,12,10Zm0,8a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V19A1,1,0,0,0,12,18Z"></path></g></svg>`,
    });
  }

  private setupLoadingListener() {
    this.router.events.subscribe((event: Event) => {
      switch (true) {
        case event instanceof NavigationStart: {
          // Complete any existing route loading task, if any before starting
          // this.loading.completeTask(this.routeLoadingTask);
          // this.routeLoadingTask = this.loading.createTask();
          // this.loadingModal = true;
          break;
        }
        case event instanceof NavigationEnd:
          // this.loading.completeTask(this.routeLoadingTask);
          // this.loadingModal = false;
          break;
        case event instanceof NavigationCancel:
        case event instanceof NavigationError: {
          break;
        }
        default: {
          break;
        }
      }
      this.cdr.detectChanges();
    });
  }
}
